// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__OHcUH","column":"IconButton_column__kSPJV","absolute":"IconButton_absolute__IJdnK","absolute-prodPage-favor":"IconButton_absolute-prodPage-favor__Ws1k5"};